import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '../constants';
import { API_ROUTES } from '../constants/apiRoutes';
import { BonusProgramType, BonusStatus, type FirstDepositBonusResponse } from '../types/bonus';
import { getData } from '../utils/api';

export const useFirstDepositBonus = () =>
  useQuery({
    queryKey: [QUERY_KEYS.firstDepositBonus],
    queryFn: (): Promise<FirstDepositBonusResponse | null> =>
      getData(API_ROUTES.FIRST_DEPOSIT_BONUS.PROGRESS, undefined, 'wallet'),
  });

export const isFirstDepositBonusActive = (
  bonus?: FirstDepositBonusResponse | null
): bonus is FirstDepositBonusResponse =>
  !!bonus &&
  bonus.status === BonusStatus.ACTIVE &&
  bonus.hasMadeFirstDeposit &&
  (!bonus.expiryDate || new Date(bonus.expiryDate) >= new Date());

export const isActiveWelcomeBonus = (bonus?: FirstDepositBonusResponse | null): bonus is FirstDepositBonusResponse =>
  isFirstDepositBonusActive(bonus) && bonus.bonusProgramType === BonusProgramType.WELCOME_BONUS && !!bonus.id;
